export interface RoutedLabel {
  text: string;
  route: string | string[];
  fragment?: string;
}
